import _ from "lodash";
import QueryPushNotification from "graphql/queries/QueryPushNotification";
import GraphqlGroupedBuilder from 'utils/request/graphql/groupedBuilder'

export default class FetchPushNotification {
	
	static fetch = ( guid, { callbackSuccess = null, callbackError = null, callbackStart = null } = {} ) => {
		GraphqlGroupedBuilder.addQuery( 'push_notification', QueryPushNotification, {
			variables: {
				guid: guid,
			},
			resultPath: [ 'employee_push_notification' ],
			callbackStart,
			callbackError,
			callbackSuccess: result => {
				const message = _.get( result, 'message', {} )
				
				if( callbackSuccess !== null && _.isFunction( callbackSuccess ) ) {
					callbackSuccess({
						pushNotification: result,
						message: message
					});
				}
			},
		})
	};
}
